import {
  isAtlasProduct,
  isBeaconProduct,
  isCompassProduct,
  isJPDProduct,
  isMercuryProduct,
  isTeamCentralProduct,
  isWhiteBoardOrCanvasProduct,
} from '@atlassian/cssxp-utils-product';

export function isPointAProduct(productKey: string): boolean {
  return (
    isCompassProduct(productKey) ||
    isTeamCentralProduct(productKey) ||
    isJPDProduct(productKey) ||
    isBeaconProduct(productKey) ||
    isWhiteBoardOrCanvasProduct(productKey) ||
    isMercuryProduct(productKey) ||
    isAtlasProduct(productKey)
  );
}
